// extracted by mini-css-extract-plugin
export default {"wrapper":"infoSlabMobile_wrapper__iEjXL","content":"infoSlabMobile_content__1Pt+B"};